import React from "react";
import ic_blue_cube from "../img/ic_blue_cube.png";
import "../css/HomePage.css";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import ic_search_menu from "../img/ic_search_menu.png";
import ic_create_menu from "../img/ic_create_menu.png";
import ic_previous_check_list from "../img/ic_previous_check_list.png";
import ic_customers_menu from "../img/ic_customers_menu.png";

function HomePage() {

    const navigate = useNavigate();

    const navigateToPage = (pagePath) => {
        let originalPagePath = "/" + pagePath;
        navigate(originalPagePath);
    }

    const goToLoginPageAgain = ()=>{
        localStorage.setItem("cubix_order_taking_isAuthenticated", false);
        navigate('/')
    }

    return (
        <div className="HomePage-root-container">

            <div className="HomePage-layer-1">
                <img src={ic_blue_cube} />
            </div>

            <div className="HomePage-layer-2 ">
                <Header />
                <h4>Options</h4>
                <div className="HomePage-layer-2-underline"></div>

                <div className="HomePage-grid-menu-container">


                    <div className="option-menu-button" onClick={() => navigateToPage("check_stock")}>
                        <img src={ic_search_menu} />
                        <span className="mt-2">Check Stock</span>
                    </div>

                    {
                        localStorage.getItem("cubix_order_taking_logged_in_person_group") != null ?
                            localStorage.getItem("cubix_order_taking_logged_in_person_group").trim() == "WORKER" ? null :

                                <div className="option-menu-button" onClick={() => navigateToPage("make_order")} >
                                    <img src={ic_create_menu} />
                                    <span className="mt-2">Make Order</span>
                                </div>
                            :
                            <div className="HomePage-login-again-bg">
                                <p>P2 issue : missing group credentials . Please login again</p>
                                <button onClick={goToLoginPageAgain}>Go to Login </button>
                            </div>
                    }

                    <div className="option-menu-button" onClick={() => navigateToPage("previous_order")}>
                        <img src={ic_previous_check_list} />
                        <span className="mt-2">Previous Orders</span>
                    </div>

                    {
                        localStorage.getItem("cubix_order_taking_logged_in_person_group") != null ?
                            localStorage.getItem("cubix_order_taking_logged_in_person_group").trim() == "WORKER" ? null :

                                <div className="option-menu-button" onClick={() => navigateToPage("customer_details")}>
                                    <img src={ic_customers_menu} />
                                    <span className="mt-2">Customer Details</span>
                                </div>
                            :
                            <div className="HomePage-login-again-bg">
                                <p>P2 issue : missing group credentials . Please login again</p>
                                <button onClick={goToLoginPageAgain}>Go to Login </button>
                            </div>
                    }

                </div>
            </div>

        </div>
    )

}

export default HomePage;

